import GlobalToasterNotification from './GlobalToasterNotification';

export default GlobalToasterNotification;
